import styled, { css } from 'styled-components';
import { screenReaderOnlyStyle } from '../../../commonStyles/screenReaderOnly';
import { stylePerBreakpoint } from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { GridItem } from '../../Grid';
import TextInput from '../TextInput';

const fractionalWidths = {
  dayAndMonth: '2/7',
  year: '3/7',
};

const padding = {
  mobile: spacing(2),
  tabletPortrait: spacing(4),
  tabletLandscape: spacing(3),
  desktop: spacing(3),
};

export const InputWrapper = styled.div`
  display: block;

  ${TextInput}:not(:first-of-type) {
    ${stylePerBreakpoint(
      (breakpoint) =>
        css`
          margin-left: ${padding[breakpoint]};
        `
    )}
  }
`;

export const DayOrMonthInput = styled(TextInput)`
  display: inline-block;

  ${stylePerBreakpoint(
    (breakpoint) =>
      css`
        width: calc(
          (100% - 2 * ${padding[breakpoint]}) * ${fractionalWidths.dayAndMonth}
        );
      `
  )}
`;

export const YearInput = styled(TextInput)`
  display: inline-block;

  ${stylePerBreakpoint(
    (breakpoint) =>
      css`
        width: calc((100% - 2 * ${padding[breakpoint]}) * ${fractionalWidths.year});
      `
  )}
`;

export const HiddenLabel = styled.label`
  ${screenReaderOnlyStyle}
`;

export const GridItemFlex = styled(GridItem)`
  display: flex;
`;
